import {
  EmailOutlined,
  FacebookOutlined,
  FileCopyOutlined,
  Google,
  Instagram,
  Public,
  TextsmsOutlined,
  YouTube
} from '@mui/icons-material'
import { IconComponent } from '@dtx-company/design-system/src/types/util'
import { LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'
import { LocgScanDestinationType } from '@app/code/src/machines/locg/locgMachine.types'
import useTranslation from 'next-translate/useTranslation'

export interface ScanDestinationOption {
  label: string
  value: LandingPageDestination
  Icon: IconComponent
}

export const useScanDestinationOptions = (): Record<
  LocgScanDestinationType,
  ScanDestinationOption
> => {
  const { t } = useTranslation('logged-out-generator')

  return {
    [LandingPageDestination.URL]: {
      label: t('LoggedOutGenerator.ScanDestination.options.url.label'),
      value: LandingPageDestination.URL,
      Icon: Public
    },
    [LandingPageDestination.FILE]: {
      label: t('LoggedOutGenerator.ScanDestination.options.file.label'),
      value: LandingPageDestination.FILE,
      Icon: FileCopyOutlined
    },
    [LandingPageDestination.SMS]: {
      label: t('LoggedOutGenerator.ScanDestination.options.sms.label'),
      value: LandingPageDestination.SMS,
      Icon: TextsmsOutlined
    },
    [LandingPageDestination.EMAIL]: {
      label: t('LoggedOutGenerator.ScanDestination.options.email.label'),
      value: LandingPageDestination.EMAIL,
      Icon: EmailOutlined
    },
    [LandingPageDestination.INSTAGRAM]: {
      label: t('LoggedOutGenerator.ScanDestination.options.instagram.label'),
      value: LandingPageDestination.INSTAGRAM,
      Icon: Instagram
    },
    [LandingPageDestination.FACEBOOK]: {
      label: t('LoggedOutGenerator.ScanDestination.options.facebook.label'),
      value: LandingPageDestination.FACEBOOK,
      Icon: FacebookOutlined
    },
    [LandingPageDestination.YOUTUBE]: {
      label: t('LoggedOutGenerator.ScanDestination.options.youtube.label'),
      value: LandingPageDestination.YOUTUBE,
      Icon: YouTube
    },
    [LandingPageDestination.GOOGLE_DOC]: {
      label: t('LoggedOutGenerator.ScanDestination.options.googleDocs.label'),
      value: LandingPageDestination.GOOGLE_DOC,
      Icon: Google
    }
  }
}
